<template>
  <div class="success-modal">
    <SuccessCheck />
    <h1 class="large-headline">{{ progressLevel }} Complete</h1>
  </div>
</template>
<script setup>
import { onMounted } from "vue";
import gsap from "gsap";
import SuccessCheck from "@/components/icons/SuccessCheck.vue";

defineProps({
  progressLevel: {
    type: String,
    default: "Step",
  },
});
const emit = defineEmits(["animationComplete"]);
onMounted(() => {
  const successTl = gsap.timeline();

  successTl.fromTo(
    ".success-modal",
    {
      duration: 0.75,
      y: 30,
      opacity: 0,
    },
    {
      y: 0,
      opacity: 1,
      delay: 0.5,
      ease: "inOut.power3",
      onComplete: () => {
        gsap.delayedCall(2, () => {
          emit("animationComplete");
        });
      },
    }
  );
});
</script>
<style lang="scss">
.success-modal {
  text-align: center;
  opacity: 0;

  svg {
    margin-bottom: 4.7rem;
  }
}
</style>
